// extracted by mini-css-extract-plugin
export default {"form":"StreetForm_form__-ja0o","button":"StreetForm_button__nEO8X"};